import classNames from 'classnames';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import CartSummary from 'cart/CartSummary';
import Item from 'common/components/item/ItemForClubTraditionalShipment';
import ItemNoEdit from 'common/components/item/ItemNoEdit';
import { getTenantId } from 'common/helpers/apiHelper';

import ClubShipDate from './ClubShipDate';
import ExchangeProductVariantModal from './ExchangeProductVariantModal';
import FrenchConnectionMessage from './FrenchConnectionMessage';
import InvalidCount from './InvalidCount';
import MinMaxProductMessage from './MinMaxProductMessage';
import NHVinoMessage from './NHVinoMessage';
import OrderValueMessage from './OrderValueMessage';
import { isShipmentAdjustable, listClubShipmentItems } from './helpers';

const ShipmentSummary = (props) => {
  const { clubPackage, clubMemberShipment, isSummaryVisibleOnMobile } = props;
  const { virtualCart } = clubMemberShipment;
  const settings = useSelector((state) => state.setting);

  const items = listClubShipmentItems(clubMemberShipment, clubPackage);
  const [modal, setModal] = useState(null);
  const [exchangeProductVariantId, setExchangeProductVariantId] =
    useState(null);
  const itemCount = items.reduce((total, item) => total + item.quantity, 0);
  const isAdjustable = isShipmentAdjustable(clubMemberShipment, clubPackage);
  const handleExchangeModal = (productVariantId) => {
    setExchangeProductVariantId(productVariantId);
    setModal('Exchange');
  };
  const handleCloseModal = () => {
    setModal(null);
    setExchangeProductVariantId(null);
  };

  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <div className="c7-checkout-summary__title c7-checkout-summary__title--hide-mobile">
        <ClubShipDate
          clubPackage={clubPackage}
          clubMemberShipment={clubMemberShipment}
          settings={settings}
        />
      </div>
      {getTenantId() === 'newsome-harlow-wines' && (
        <div className="c7-checkout-summary__notes">
          <NHVinoMessage clubPackage={clubPackage} />
        </div>
      )}
      {getTenantId() !== 'newsome-harlow-wines' && (
        <div className="c7-checkout-summary__notes">
          <MinMaxProductMessage
            clubPackage={clubPackage}
            itemCount={itemCount}
          />
          <FrenchConnectionMessage />
          <OrderValueMessage clubPackage={clubPackage} settings={settings} />
          <InvalidCount clubPackage={clubPackage} itemCount={itemCount} />
        </div>
      )}{' '}
      <div className="c7-cart-items c7-cart-items--club-shipment">
        {items.map((item) => {
          if (!isAdjustable) {
            return <ItemNoEdit item={item} key={item.id} settings={settings} />;
          }
          return (
            <Item
              item={item}
              clubPackage={clubPackage}
              clubMemberShipment={clubMemberShipment}
              key={item.id}
              onExchange={handleExchangeModal}
            />
          );
        })}
      </div>
      {virtualCart && <CartSummary cart={virtualCart} />}
      <div className="c7-checkout-summary__buttons">
        <a href="/profile/club-membership" className="c7-button">
          Return To Club Membership
        </a>
      </div>
      {renderModal(
        modal,
        handleCloseModal,
        exchangeProductVariantId,
        clubPackage,
        clubMemberShipment
      )}
    </section>
  );
};

export default ShipmentSummary;

const renderModal = (
  modal,
  handleCloseModal,
  exchangeProductVariantId,
  clubPackage,
  clubMemberShipment
) => {
  switch (modal) {
    case 'Exchange': {
      return (
        <ExchangeProductVariantModal
          onCloseModal={handleCloseModal}
          productVariantId={exchangeProductVariantId}
          clubPackage={clubPackage}
          clubMemberShipment={clubMemberShipment}
        />
      );
    }
    default: {
      return null;
    }
  }
};
